import Vue from 'vue'
import seasonApi from '@/api/season.api'

const state = {
  currentId: null,
  seasons: {},
  seasonsLoaded: false
}


const getters = {
  currentSeasonId: (state) => {
    return state.currentId
  },

  currentSeason: (state) => {
    return state.seasons[state.currentId]
  },

  seasonById: (state) => (id) => {
    return state.seasons[id]
  },

  seasons: (state) => {
    return Object.values(state.seasons) || []
  }
}


const actions = {
  async loadSeasons ({ commit, rootState }) {
    commit('SET_SEASONS_LOADED', false)
    const response = await seasonApi.getSeasons(rootState.tenant.current)
    commit('SET_SEASONS', response.data)
    commit('SET_SEASONS_LOADED', true)
  },

  async loadAndUpdateSeason ({ commit, rootState }, entityData) {
    const response = await seasonApi.getSeasonById(rootState.tenant.current, entityData.entityId)
    commit('UPDATE_SEASON', response.data)
    return response.data
  },

  async loadRelations ({ commit, rootState }, id) {
    const response = await seasonApi.getRelations(rootState.tenant.current, id)
    return response.data
  },

  async createSeason ({ commit, rootState }, season) {
    const response = await seasonApi.createSeason(rootState.tenant.current, season)
    commit('CREATE_SEASON', response.data)
  },

  async updateSeason ({ commit, rootState }, season) {
    const response = await seasonApi.updateSeason(rootState.tenant.current, season.id, season)
    commit('UPDATE_SEASON', response.data)
  },

  async deleteSeason ({ commit, getters, rootState }, { id }) {
    await seasonApi.deleteSeason(rootState.tenant.current, id)
    commit('DELETE_SEASON', id)
  },


  setCurrentSeason ({ commit, getters }, id) {
    if (!id && getters.seasons.length > 0) {
      id = getters.seasons[0].id
    }
    commit('SET_CURRENT_ID', id ?? null)
  }
}


const mutations = {
  SET_SEASONS (state, seasons) {
    state.seasons = {}
    for (const season of seasons) {
      Vue.set(state.seasons, season.id, season)
    }
  },

  SET_SEASONS_LOADED (state, loaded) {
    state.seasonsLoaded = loaded
  },

  SET_CURRENT_ID (state, id) {
    state.currentId = id
  },

  CREATE_SEASON (state, season) {
    Vue.set(state.seasons, season.id, season)
  },

  UPDATE_SEASON (state, season) {
    Vue.set(state.seasons, season.id, season)
  },

  DELETE_SEASON (state, id) {
    Vue.delete(state.seasons, id)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
